export default {
  init() {
    // Generate pseudo GUID
    function generateGuid() {
      function s4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        s4() + s4() + '-' +
        s4() + '-4' + s4().substr(0, 3) + '-' +
        s4() + '-' +
        s4() + s4() + s4()
      ).toLowerCase();
    }

    const guid = generateGuid();
    const guidAlt = generateGuid();

    /**
     * Apply GUID logic to a given Gravity Form
     * @param {number} id Gravity Form ID
     */
    function bindForm(id) {
      const base = `#input_${id}_`;

      if (!jQuery(base + '65').length) return; // Skip if form not present

      jQuery(base + '65').val(guid);

      jQuery(`#choice_${id}_68_1`).on('change', function () {
        jQuery(base + '66').val(guidAlt);
        jQuery(base + '67').val(jQuery(base + '65').val());
      });

      jQuery(`#choice_${id}_1_0`).on('change', function () {
        if (jQuery(this).is(':checked')) jQuery(base + '69').val('true');
      });

      jQuery(`#choice_${id}_1_1`).on('change', function () {
        if (jQuery(this).is(':checked')) jQuery(base + '69').val('false');
      });
    }

    // Register this logic for all matching forms
    [2, 11].forEach(bindForm);
  },

  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/templateResellers.js